/**
 * External dependencies
 */
import React from "react";
import classNames from "classnames";
import { Box } from "@towersystems/towersystems-design-system";

/**
 * Style dependencies
 */
import "./styles.scss";

const ButtonGroup = ({ children, className, ...rest }) => {
  const classes = classNames("button-group", className);
  return (
    <Box className={classes} display="flex" alignItems="center" {...rest}>
      {children}
    </Box>
  );
};

export default ButtonGroup;
